import sortBy from "lodash/sortBy";

export const HEALTHCARE_INDUSTRY = "HEALTHCARE";
const OTHER = "OTHER";

export const jobIndustryLookup = {
  ACCOUNTING: "Accounting",
  ADMINISTRATION: "Administration",
  AGRICULTURE: "Agriculture",
  AVIATION: "Aviation & Aerospace",
  BUSINESS: "Business Management",
  CHARITY: "Volunteering & Charity",
  COMPLIANCE: "Compliance",
  CONSTRUCTION: "Construction",
  DESIGN: "Design & Creative Services",
  EDUCATION: "Education & Research",
  ENERGY: "Energy",
  ENGINEERING: "Engineering",
  ENTERTAINMENT: "Entertainment (Film, Theatre & Music)",
  FASHION: "Fashion",
  FINANCE: "Finance & Economics",
  FOREX: "FOREX",
  GAMBLING: "Gambling & Casino",
  HEALTHCARE: "Healthcare",
  HORECA: "HORECA",
  HOSPITALITY: "Food & Beverage",
  HR: "Human Resources",
  LAW: "Legal Services",
  LOGISTICS: "Logistics & Supply Chain",
  MAINTENANCE: "Maintenance & Installation",
  MANUFACTURING: "Manufacturing",
  MARITIME: "Maritime & Shipping",
  MARKETING: "Advertising & Marketing",
  MEDIA: "Media & News",
  MINING: "Mining, Oil & Gas",
  OPERATIONS: "Operations",
  PHOTOGRAPHY: "Film, Video & Photography",
  PROCUREMENT: "Procurement",
  PUBLIC: "Public Sector (Government) Services",
  REAL: "Real Estate",
  RETAIL: "Retail",
  RISK: "Risk",
  SALES: "Sales & Business Development",
  SCIENCE: "Science",
  SECURITY: "Security Services",
  SOFTWARE: "Software Development",
  SPA: "Spa & Beauty",
  SUPPORT: "Customer Services",
  TECHNOLOGY: "Computer & Technology",
  TELECOMMUNICATIONS: "Telecommunications",
  TRANSPORT: "Transportation (Drivers)",
};

export function getJobIndustry(industry) {
  return jobIndustryLookup[industry] || industry;
}

export const INDUSTRY_LIST = [
  ...Object.entries(jobIndustryLookup).map((e) => ({
    text: getJobIndustry([e[0]]),
    value: e[0],
  })),
];

const otherIndustry = {
  text: "Other",
  value: OTHER,
  key: INDUSTRY_LIST.length + 1,
};

export const DROP_DOWN_INDUSTRY_OPTIONS = [
  ...sortBy(INDUSTRY_LIST, "text").map((item, index) => ({
    ...item,
    key: index + 1,
  })),
  otherIndustry,
];
